'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoTrashA = function IoTrashA(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.4 10h7.1v2.5h-0.7s-0.4 0.1-0.6 0.3-0.3 0.7-0.3 0.7l-1.5 18.8c-0.2 2.3-0.2 2.7-2.8 2.7h-15.7c-2.6 0-2.6-0.4-2.8-2.7l-1.5-18.9s0-0.4-0.3-0.7-0.6-0.2-0.6-0.2h-0.7v-2.5h7.1v-2.3c0-1.4 1.1-2.7 2.7-2.7h7.9c1.5 0 2.7 1.3 2.7 2.7v2.3z m-11.6-2.3v2.3h10v-2.3c0-0.7-0.8-1.1-1.5-1.1h-7.1c-0.8 0-1.4 0.4-1.4 1.1z m-0.7 22.3h1.6l-0.8-15h-1.6z m6.5 0v-15h-1.7v15h1.7z m4.9 0l0.7-15h-1.5l-0.9 15h1.7z' })
        )
    );
};

exports.default = IoTrashA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/trash-a.js
// module id = 2746
// module chunks = 0